import React, { Component } from 'react';
import axios from 'axios';
import { Link, withRouter } from 'react-router-dom';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';

class Cities extends Component {
  render() {
    var filteredCities = this.props.cities
      .filter(c => {
        return (
          (!this.state.filterState || c.state_id === this.state.filterState) &&
          (!this.state.filterSize ||
            c.populationGroup === this.state.filterSize)
        );
      })
      .sort((a, b) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      });
    let dropDownStyle = {
      backgroundColor: '#F0F0F0',
      height: '35px',
      lineHeight: '35px',
      overflow: 'inherit',
    };
    let iconStyle = {
      height: '35px',
      top: '-7px',
      fill: '#bdbdbd',
      right: '-5px',
    };
    return (
      <div className="">
        <div className="dropDownMenus flex flex-center ">
          <div className="mr2 ">
            <DropDownMenu
              style={dropDownStyle}
              labelStyle={dropDownStyle}
              iconStyle={iconStyle}
              underlineStyle={{ display: 'none' }}
              value={this.state.filterSize}
              onChange={this.handlePopChange}
            >
              {this.state.populationGroups.map((s, i) => {
                return <MenuItem key={i} value={i} primaryText={s} />;
              })}
            </DropDownMenu>
          </div>
          <div className="mx2">
            <DropDownMenu
              style={dropDownStyle}
              labelStyle={dropDownStyle}
              iconStyle={iconStyle}
              underlineStyle={{ display: 'none' }}
              maxHeight={300}
              value={this.state.filterState}
              onChange={this.handleStateChange}
            >
              <MenuItem key={0} value={0} primaryText="All States" />
              {this.state.states.map((s, i) => {
                return (
                  <MenuItem
                    key={s.abbreviation}
                    value={s.id}
                    primaryText={s.title}
                  />
                );
              })}
            </DropDownMenu>
          </div>
          <div
            onClick={this.clearFilters}
            className={
              'mx2 cursor ' +
              (!this.state.filterState &&
                !this.state.filterSize &&
                'display-none')
            }
          >
            clear filters X
          </div>
        </div>

        <div className="clearfix">
          {filteredCities.map(c => {
            if (!c || !c.title || !c.state || !c.state.title) return null;
            return (
              <Link
                className="col lg-col-3 city md-col-12 sm-col-12 col-12"
                key={c.slug}
                to={{
                  pathname: '/cities/' + c.slug,
                  search: this.props.location.search,
                }}
              >
                <div className="relative">
                  <img
                    className="block"
                    src={
                      c.photo
                        ? 'https://res.cloudinary.com/gates/image/upload/c_fill,h_300,w_300/' +
                          c.photo
                        : 'https://dummyimage.com/300x300/888/fff.png&text=Add+Image'
                    }
                    alt={c.title}
                  />
                  <div className="white align-center absolute top-0 bottom-0 left-0 right-0">
                    <div className="golden-gradient absolute top-0 bottom-0 left-0 right-0" />
                    <div className="citySquareTitle bold relative ">
                      {c.title}
                    </div>
                    <div className="citySquareState relative">
                      {c.state.title}
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    );
  }

  constructor() {
    super();
    this.state = {
      populationGroups: [
        'All Population Groups',
        'under 500k',
        '500k - 1M',
        'over 1M',
      ],
      states: [],
      filterState: 0,
      filterSize: 0,
    };
    this.handlePopChange = this.handlePopChange.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.getCities();
  }

  handlePopChange(event, key, value) {
    this.setState({ filterSize: parseInt(value, 10) });
  }

  handleStateChange(event, key, value) {
    this.setState({ filterState: parseInt(value, 10) });
  }

  clearFilters(event) {
    this.setState({
      filterState: 0,
      filterSize: 0,
    });
  }

  getCities() {
    axios
      .get('/state')
      .then(p => {
        this.setState({ states: p.data });
      })
      .catch(error => {
        console.log(error);
      });
  }
}

export default withRouter(Cities);



// WEBPACK FOOTER //
// ./src/components/CityList.jsx